export default ({ validation, style, item }) => ({
  control: (baseStyles, state) => ({
    flex: '1',
    display: 'flex',
    width: '100% !important',
    minHeight: '100%',
    border: `${
      validation
        ? '2px solid red'
        : `${state.menuIsOpen || state.isFocused ? '1px solid #79BC61' : '1px solid #D3D6D2'}`
    }`,
    borderRadius: `6px`,
    overflow: 'hidden',
    background: `white`,
    transition: 'all 0.2s ease',
    fontSize: '14px',
    paddingLeft: item.size === 'sm' ? '0px' : '16px',
    boxShadow: `${
      state.menuIsOpen || state.isFocused
        ? '0px 0px 0px 4px #E2EEDA'
        : '0px 1px 3px rgba(16, 24, 40, 0.03), 0px 2px 4px rgba(16, 24, 40, 0.05);'
    }`,
    '&:hover': {
      borderColor: '#79BC61', // Control hover color
    },
    ...style?.control,
  }),
  menu: (baseStyles, state) => ({
    overflow: 'hidden',
    border: `${validation ? '1px solid red' : '1px solid #79BC61'}`,
    marginTop: '4px',
    paddingLeft: '4px',
    paddingRight: '4px',
    borderRadius: '6px',
    marginBottom: '30px !important',
    whiteSpace: 'nowrap',
    position: 'absolute',
    background: '#ffffff',
    width: '100%',
    zIndex: 1000,
    boxShadow: `0px 0px 0px 4px #E2EEDA`,
    ...style?.menu,
  }),

  option: (provided, state) => {
    const sizeType = {
      sm: '8px 8px',
      md: '12px 12px',
      lg: '16px 20px',
    }
    const fontSize = {
      sm: '14px',
      md: '14px',
      lg: '18px',
    }
    return {
      //minHeight: '45px',
      //display: 'flex',
      alignItems: 'center',
      paddingLeft: '17px',
      borderRadius: '4px',
      background: state.isSelected ? '#EBF4E8' : state.isFocused ? '#F5F9F7' : '',
      color: state.isSelected ? '#598C4A' : '#000',
      transition: 'all 0.2s ease',
      cursor: state.isSelected ? 'default' : 'pointer',
      position: 'relative',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'wrap',
      padding: sizeType[item?.size],
      minWidth: 0,
      fontSize: fontSize[item?.size],
      margin: '1px 0px',

      ...style?.option,
    }
  },
  multiValue: (provided, state) => ({
    ...provided,
    background: '#C2E1B7',
    paddingLeft: '4px',
    paddingRight: '0px',
    borderRadius: '40px',
    fontSize: '16px !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...style?.multiValue,
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    color: '#69A455',
    borderRadius: '48px',
    transition: 'all 0.2s ease',
    padding: '0px',
    ':hover': {
      backgroundColor: '#79BC61',
      color: 'white',
    },
    height: '22px',
    width: '22px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '2px',
    marginLeft: '5px',
    ...style?.multiValueRemove,
  }),
  container: (provided, state) => ({
    ...provided,
    ...style?.container,
  }),
  menuPortal: (provided, state) => ({
    ...provided,
    zIndex: '1000',
  }),
})
